/* import __COLOCATED_TEMPLATE__ from './topic-category.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
// Injections don't occur without a class
import TEMPLATE from "./topic-category.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend());